import axj_web_getters from './axj-web/getters'
import common_getters from './common/getters'
import axj_help_getters from './axj_help/getters'
export default {
  ...axj_web_getters,
  ...common_getters,
  ...axj_help_getters
}



// WEBPACK FOOTER //
// ./src/store/getters.js